<template>
<!-- Footer -->
<MDBFooter :text="['center', 'lg-start', 'muted']">
    <div class="row justify-content-center">
        <!-- LinkedIn Icon -->
        <div class="col-auto icon lnk">
            <a href="https://www.linkedin.com/company/codex-earth/"><i class="fab fa-linkedin-in"></i></a>
        </div>

        <!-- GitHub Icon -->
        <div class="col-auto icon git">
            <a href="https://github.com/CodexEarth"><i class="fab fa-github"></i></a>
        </div>

        <!-- YouTube Icon -->
        <div class="col-auto icon yt">
            <a href="https://www.youtube.com/channel/UCsC01SddFaYFxIK9RipYMKg"><i class="fab fa-youtube"></i></a>
        </div>
    </div>

    <!-- Section: Links  -->
    <section id="about">
        <MDBContainer class="text-center text-md-start mt-5">
            <!-- Grid row -->
            <MDBRow class="mt-3">
                <!-- Grid column -->
                <MDBCol md="6" lg="6" xl="6" class="mx-auto mb-4">
                    <!-- Content -->
                    <h6 class="text-uppercase fw-bold mb-4">

                        <div class="display-5 h5" style="font-weight: bold;">
                            <i class="fa-solid fa-building fa-fade fa-md link-secondary"></i>
                            <span style="color: rgb(3, 3, 139);"> Codex</span>
                            <span style="color: black;"> Earth</span>
                        </div>
                    </h6>
                    <p style="font-weight: bold;">
                        Our IT service company offers internships to students who are interested in gaining practical experience in the field of IT. Our internship program is designed to provide students with hands-on training and exposure to real-world projects, while also giving them the opportunity to work alongside experienced professionals in the industry. We are committed to helping students develop the skills and knowledge they need to succeed in their future careers.
                    </p>
                </MDBCol>

                <MDBCol md="6" lg="6" xl="6" class="mx-auto mb-md-0 mb-4" id="address">
                    <!-- Links -->
                    <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
                    <p>
                        <i class="fas fa-home me-3 link-secondary"></i> Mumbai,
                        INDIA
                    </p>
                    <p>
                        <i class="fas fa-envelope me-3 link-secondary"></i>
                        codexearth30@gmail.com
                    </p>
                    <p>
                        <MDBIcon />

                    </p>
                </MDBCol>
                <!-- Grid column -->
            </MDBRow>
            <!-- Grid row -->
        </MDBContainer>
    </section>
    <!-- Section: Links  -->

    <!-- Copyright -->
    <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05)">
        © 2023 Copyright:
        <a class="text-reset fw-bold" href="https://codexearth.in/" style="text-decoration: none;">Codex Earth</a> All rights reserved.
    </div>
    <!-- Copyright -->
</MDBFooter>
<!-- Footer -->
</template>

<script>
import {
    MDBFooter,
    MDBIcon,
    MDBRow,
    MDBCol,
    MDBContainer
} from "mdb-vue-ui-kit";

export default {
    components: {
        MDBFooter,
        MDBIcon,
        MDBRow,
        MDBCol,
        MDBContainer
    }
}
</script>

<style>
.icon {
    width: 50px;
    height: 60px;
    border-radius:20%;
    /* Set border-radius to 50% for a circular shape */
    margin: 20px;
    text-align: center;
    font-size: 30px;
    line-height: 50px;
    /* Match the height for vertical alignment */
    font-family: sans-serif;
    overflow: hidden;
    transition: all .3s ease-out;
}

.icon:hover {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon:hover i {
    color: #fff;
}

.icon .fa-facebook-f {
    color: #1A6ED8;
}

.fb:hover {
    background: #13e86c;
}

.twt:hover {
    background: #1DA1F2;
}

.icon .fa-linkedin-in {
    color: #0077B5;
}

.lnk:hover {
    background: #0077B5;
}

.icon .fa-github {
    color: #000;
}

.git:hover {
    background: #000;
}

.icon .fa-youtube {
    color: #FE0000;
}

.yt:hover {
    background: #FE0000;
}

#address {

    text-align: center;
    margin-top: 2rem;
}
</style>
